import { render, staticRenderFns } from "./serviceOrderList.vue?vue&type=template&id=b291f2c6"
import script from "./serviceOrderList.vue?vue&type=script&lang=js"
export * from "./serviceOrderList.vue?vue&type=script&lang=js"
import style0 from "./serviceOrderList.vue?vue&type=style&index=0&id=b291f2c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports